export const distributorFields = {
  addDistributor: {
    email: 'email',
    roleId: 'roleId',
  },
};
